"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _client = require("@apollo/client");

var _default = function _default(_ref) {
  var objectId = _ref.objectId,
      object = _ref.object,
      query = _ref.query,
      dataKey = _ref.dataKey;

  // console.log(objectId, !!object)
  var _useQuery = (0, _client.useQuery)(query, {
    skip: !!object,
    pollInterval: !object ? 3000 : 0,
    variables: {
      id: objectId
    }
  }),
      data = _useQuery.data;

  return (0, _react.useMemo)(function () {
    return object !== null && object !== void 0 ? object : data === null || data === void 0 ? void 0 : data[dataKey];
  }, [JSON.stringify(object !== null && object !== void 0 ? object : data === null || data === void 0 ? void 0 : data[dataKey])]);
};

exports["default"] = _default;